import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
    AtomsProvider,
    LocalizationContextProvider,
    PageName,
    localizationDataAtom,
    pageNameAtom,
    floatingChatDataAtom,
} from '@fiverr-private/seller_pages_toolbox';
import { ComplianceProvider } from '@fiverr-private/compliance';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    agencyAtom,
    gigsAtom,
    reviewsAtom,
    customOrderModalAtom,
    rolloutsAtom,
    agencySellerAtom,
    loyaltyDataAtom,
} from '../../atoms';
import { AgencyPage } from '../../components/AgencyPage';
import { AppProps } from './types';

const App = ({
    agency,
    currency,
    gigs,
    localization,
    reviews,
    seller,
    rollouts,
    loyaltyData,
    floatingChatData,
    complianceData,
}: AppProps) => {
    const queryClient = React.useMemo(() => new QueryClient(), []);
    const { userId, organizationId } = getContext();
    const pageName = 'agency_page' as PageName;

    return (
        <AtomsProvider
            atoms={[
                [agencyAtom, agency],
                [gigsAtom, gigs],
                [localizationDataAtom, localization],
                [reviewsAtom, reviews],
                [agencySellerAtom, seller],
                [pageNameAtom, pageName],
                [customOrderModalAtom, { isOpen: false, data: null }],
                [rolloutsAtom, rollouts],
                [loyaltyDataAtom, loyaltyData],
                [floatingChatDataAtom, floatingChatData],
            ]}
        >
            <QueryClientProvider client={queryClient}>
                <ComplianceProvider
                    complianceData={complianceData?.value?.state}
                    requester_id={userId}
                    organizationId={organizationId}
                    pageName={pageName}
                >
                    <LocalizationContextProvider currency={currency}>
                        <AgencyPage />
                    </LocalizationContextProvider>
                </ComplianceProvider>
            </QueryClientProvider>
        </AtomsProvider>
    );
};

export default App;
